if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener("submit", this.onSubmitHandler);
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        if (!this.form) return;

        const submitButton = this.querySelector('[name="add"]');
        if (!submitButton || submitButton.disabled) return;

        submitButton.disabled = true;
        submitButton.classList.add("loading");
        this.handleErrorMessage(false);

        let addedSuccessfully = false;

        try {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);

          if (this.cartNotification) {
            formData.append(
              "sections",
              this.cartNotification
                .getSectionsToRender()
                .map((section) => section.id)
            );
            this.cartNotification.setActiveElement(document.activeElement);
          }

          if (this.cartItems) {
            formData.append(
              "sections",
              this.cartItems
                .getSectionsToRender()
                .map((section) => section.section)
            );
          }

          formData.append("sections_url", window.location.pathname);
          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            const errorMessage =
              parsedState.description ||
              parsedState.message ||
              window.cartStrings?.error ||
              "Unable to add this item to the cart.";
            this.handleErrorMessage(errorMessage);
            return;
          }

          if (this.cartNotification) {
            this.cartNotification.renderContents(parsedState);
          }

          if (this.cartItems) {
            this.cartItems.renderContents(parsedState);
          }

          addedSuccessfully = true;

          this.querySelector(".product-form__error-message-wrapper")?.classList.add(
            "no-js-inline"
          );
        } catch (error) {
          console.error("Unable to add product to cart", error);
          this.handleErrorMessage(
            window.cartStrings?.error || "Unable to add this item to the cart."
          );
        } finally {
          submitButton.classList.remove("loading");

          if (submitButton.dataset.variantAvailable !== "false") {
            submitButton.disabled = false;
          }

          if (addedSuccessfully) {
            if (typeof closeQuickViewModal === "function") {
              closeQuickViewModal();
            } else {
              this.quickViewWarpper?.classList.remove("show__modal");
              document.body.classList.remove("overflow-hidden");
              document
                .querySelector("quick-view-modal button.active")
                ?.classList.remove("active");
            }
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");

        if (!this.errorMessageWrapper) {
          if (errorMessage) console.error(errorMessage);
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
